<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Product Prices</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Prices
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-right col-md-6 col-12 mb-md-0 mb-2">
                <div class="row">
                    <div class="col-md-5">
                        <button @click.prevent="deleteSizeModal" data-toggle="modal" data-target="#faq-modal"
                                type="button"
                                class="btn btn-outline-danger float-md-right"><i
                            class="feather icon-plus icon-left"></i>
                            Delete Size
                        </button>
                    </div>
                    <div class="col-md-7">
                        <button @click.prevent="addPriceModal" data-toggle="modal" data-target="#faq-modal"
                                type="button"
                                class="btn btn-outline-primary float-md-right"><i
                            class="feather icon-plus icon-left"></i>
                            Update/Add Product Price
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Product Prices for {{ this.product.name }}</h4>
                </div>

                <div class="card-body">
                    <list-controls
                        :search.sync="search"
                        search-id="price-search"
                        placeholder="Search by store, size, or price"
                        show-filters
                        @apply="applyFilters"
                        @reset="resetFilters"
                    >
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="price-store">By Store</label>
                                <select id="price-store" class="form-control form-control-sm" v-model="filters.store_id">
                                    <option :value="null">All</option>
                                    <option v-for="store in stores" :key="store.id" :value="store.id">
                                        {{ store.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="price-size">By Size</label>
                                <select id="price-size" class="form-control form-control-sm" v-model="filters.size_id">
                                    <option :value="null">All</option>
                                    <option v-for="size in sizes" :key="size.id" :value="size.id">
                                        {{ size.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </list-controls>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allPrices"
                        ref="myTable"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <a href="#"
                                   class="dropdown-item"
                                   @click.prevent="editPriceModal(props.row.price, props.row.discount_price, props.row.id )">
                                    <i class="feather icon-edit"></i>
                                    Change Price
                                </a>
                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>

        <div class="modal fade add-price-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
             aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <form @submit.prevent="addPrice">
                        <div class="modal-header"><h4 id="myModalLabel1" class="modal-title">
                            {{ this.isEditing ? "Edit" : "Add" }} Product Price</h4>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span
                                aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <template v-for="(n,index) in formCount">
                                <template v-if="!isEditing">
                                    <div class="form-group">
                                        <div class="controls">
                                            <label class="form-label">Associated Store</label>
                                            <select v-model="price[index].store_id" id="" class="form-control">
                                                <option value="" selected>Select the Store
                                                </option>
                                                <option v-for="store in stores" :key="store.id"
                                                        :value="store.id">
                                                    {{ store.name }}
                                                </option>
                                            </select>
                                            <small class="text-danger">If no store is selected, the price will be
                                                updated across all stores</small>
                                            <!--                                            <span v-if="price.errors.store_id"-->
                                            <!--                                                  class="text-danger text-small">{{ price.errors.store }}</span>-->
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <div class="controls">
                                                    <label class="form-label">Product Size</label>
                                                    <select v-model="price[index].size_id" id="" class="form-control"
                                                            required>
                                                        <option value="" selected>Select a Product Size for the price
                                                        </option>
                                                        <option v-for="size in sizes" :key="size.id"
                                                                :value="size.id">
                                                            {{ size.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group"><label>Product Price</label>
                                                <input type="number" required="required" v-model="price[index].price"
                                                       class="form-control">
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="form-group"><label>Product Discount Price</label>
                                                <input type="number" v-model="price[index].discount_price"
                                                       class="form-control">
                                                <small class="text-danger">Please leave this empty if you do not want a
                                                    discount price for this product</small>
                                            </div>
                                        </div>

                                    </div>
                                </template>
                            </template>

                            <template v-if="isEditing">
                                <div class="form-group"><label>Product Price</label>
                                    <input type="number" required="required" v-model="editedPrice.price"
                                           class="form-control">
                                    <div v-if="editedPrice.price" class="text-danger text-small">
                                        {{ editedPrice.errors.price }}
                                    </div>
                                </div>
                                <div class="form-group"><label>Product Discount Price</label>
                                    <input type="number" v-model="editedPrice.discount_price"
                                           class="form-control">
                                    <div v-if="editedPrice.discount_price" class="text-danger text-small">
                                        {{ editedPrice.errors.discount_price }}
                                    </div>
                                    <small class="text-danger">Please leave this empty if you do not want a discount
                                        price for this product</small>
                                </div>
                            </template>

                            <template v-if="!isEditing">
                                <span>
                                    <a href="#" @click="addToFormCount">Add +</a>
                                </span>

                                <span v-if="formCount>1">
                                    <a href="#" @click="subtractFromFormCount" class="text-danger">- Remove</a>
                                </span>
                            </template>
                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-primary" :disabled="saving">
                                Save <i class="fa fa-spinner fa-spin" v-if="saving"/>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="modal fade delete-size-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel1"
             aria-hidden="true">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <form @submit.prevent="deleteProductSize">
                        <div class="modal-header"><h4 id="myModalLabel1" class="modal-title">
                            Delete Product Size</h4>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span
                                aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <div class="controls">
                                    <label class="form-label">Size to Delete</label>
                                    <select v-model="deleteSize.size_id" id="" class="form-control">
                                        <option :value="null">Select the Size
                                        </option>
                                        <option v-for="size in availableSizes" :key="size.id"
                                                :value="size.id">
                                            {{ size.name }}
                                        </option>
                                    </select>
                                    <span class="text-danger">This action will permanently delete this specific product size from all stores across the application. This cannot be undone, only proceed if you are sure you want to remove this size from every store.</span>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-danger" :disabled="saving">
                                Delete <i class="fa fa-spinner fa-spin" v-if="saving"/>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import ListControls from '@/Shared/ListControls';
import DeleteAlert from "../../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../../Shared/Mixins/PaginationMixin";
import ListQueryMixin from "../../../Shared/Mixins/ListQueryMixin";

export default {
    metaInfo: {title: 'Product Prices'},
    props: [
        'prices',
        'product',
        'stores',
        'sizes',
    ],
    layout: Layout,
    components: {
        Link,
        ListControls,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
        ListQueryMixin,
    ],
    data() {
        return {
            formCount: 1,
            deleteSize: {
                size_id: null,
                product_id: null,
            },
            availableSizes: [],
            price: [{
                price: null,
                discount_price: null,
                store_id: "",
                size_id: "",
                id: null,
            }],
            editedPrice: this.$inertia.form({
                discount_price: null,
                price: null,
                id: null,
            }),
            filters: {
                store_id: null,
                size_id: null,
            },
            isLoadingFilter: false,
            allPrices: [],
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10
            },

            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },

            sortingOptions: {
                enabled: false,
            },

            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Store Name', field: 'store.name', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Size Name', field: 'size.name', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Price',
                    field: 'price',
                    thClass: 'text-center',
                    formatFn: (value) => '₦' + value,
                    tdClass: 'text-center'
                },
                {
                    label: 'Discount Price',
                    field: 'discount_price',
                    thClass: 'text-center',
                    formatFn: (value) => value === null ? 'N/A' : '₦' + value,
                    tdClass: 'text-center'
                },
                {label: 'Action', field: 'action', sortable: false, thClass: 'text-center', tdClass: 'text-center'},
            ],
            tableDataLoading: false,
            saving: false,
            isEditing: false,
        }
    },

    mounted() {
        this.allPrices = this.prices.data;
        this.totalRecords = this.prices.total
    },

    watch: {
        prices: {
            handler(newPrices) {
                if (newPrices?.data) {
                    this.allPrices = newPrices.data;
                    this.totalRecords = newPrices.total;
                }
            },
            deep: true,
        },
    },

    methods: {
        showFlash(type, message) {
            this.$page.props.flash.success = null;
            this.$page.props.flash.error = null;

            this.$nextTick(() => {
                if (type === 'success') {
                    this.$page.props.flash.success = message;
                    return;
                }

                this.$page.props.flash.error = message;
            });
        },
        addToFormCount() {
            this.formCount += 1;
            this.price.push({
                price: null,
                store_id: "",
                size_id: "",
                id: null,
            });
        },
        subtractFromFormCount() {
            if (this.formCount > 1) {
                this.formCount -= 1;
                this.price.pop();
            } else {
                this.formCount = 1;
            }
        },
        addPriceModal() {
            $('.add-price-modal').modal('show');
            this.price.price = ""
            this.price.disocunt_price = ""
            this.price.store_id = ""
            this.price.size_id = ""
            this.isEditing = false;
        },

        deleteSizeModal() {
            $('.delete-size-modal').modal('show');
            this.deleteSize.size_id = null
            this.deleteSize.product_id = this.product.id
            this.isEditing = false;
            this.fetchAvailableSizes()
        },
        async editPriceModal(price, discount_price, resourceId) {
            this.editedPrice.price = price;
            this.editedPrice.discount_price = discount_price
            this.isEditing = true;
            this.editedPrice.id = resourceId
            $('.add-price-modal').modal('show');
        },

        resetEditForm() {
            this.isEditing = false;
            this.editedPrice.reset();
            this.editedPrice.clearErrors();
        },

        closePriceModal() {
            $('.add-price-modal').modal('hide');
            this.resetEditForm();
        },

        async handlePriceSaveSuccess(fallbackMessage) {
            this.saving = false;
            this.closePriceModal();

            const message = this.$page.props.flash?.success || fallbackMessage;
            this.showFlash('success', message);
            await this.paginatedData();
        },

        handlePriceSaveError(fallbackMessage) {
            this.saving = false;

            const message = this.$page.props.flash?.error || fallbackMessage;
            this.showFlash('error', message);
        },

        async addPrice() {
            this.saving = true;

            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    if (this.$page.props.flash?.error) {
                        this.handlePriceSaveError(
                            this.isEditing
                                ? 'Product Price not updated, Try again'
                                : 'Product Price not added, Try again'
                        );

                        return;
                    }

                    this.handlePriceSaveSuccess(
                        this.isEditing
                            ? 'Product Price updated successfully'
                            : 'Product Price added successfully'
                    );
                },
                onError: () => {
                    this.handlePriceSaveError(
                        this.isEditing
                            ? 'Product Price not updated, Try again'
                            : 'Product Price not added, Try again'
                    );
                },
                onFinish: () => {
                    this.saving = false;
                },
            };

            if (this.isEditing) {
                await this.editedPrice.put(route('admin.products.prices.update', this.editedPrice.id), options);
                return;
            }

            await this.$inertia.post(route('admin.products.prices.store', this.product.id), {price: [...this.price]}, options);
        },
        async deleteProductSize() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                    $('.delete-size-modal').modal('hide');

                    if (this.$page.props.flash?.error) {
                        this.showFlash('error', this.$page.props.flash.error);
                        return;
                    }

                    this.showFlash('success', this.$page.props.flash?.success || 'Product Size deleted successfully');
                    this.paginatedData();
                },
                onError: () => {
                    this.saving = false;
                    this.showFlash('error', 'Product Size not deleted, Try again');
                },
                onFinish: () => {
                    this.saving = false;
                },
            };

            await this.$inertia.delete(route('admin.products.prices.sizes.delete', [this.deleteSize.product_id, this.deleteSize.size_id]), {}, options);
        },
        paginatedData() {
            return this.loadList('admin.products.prices.index', 'allPrices', this.product.id);
        },
        async deletePrice(id) {
            await this.$inertia.delete(route('admin.products.prices.delete', id), {
                preserveScroll: true,
                onSuccess: () => {
                    if (this.$page.props.flash?.error) {
                        this.showFlash('error', this.$page.props.flash.error);
                        return;
                    }

                    this.showFlash('success', this.$page.props.flash?.success || 'Product Price deleted successfully');
                    this.paginatedData();
                },
                onError: () => {
                    this.showFlash('error', 'Product Price not deleted, Try again');
                },
            })
        },
        async fetchAvailableSizes() {
            try {
                let response = await axios.get(route('admin.products.prices.sizes', this.product.id), {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });
                this.availableSizes = response.data.data
            } catch (e) {
                console.log(e);
            }
        },
        async showAlert(sizeId) {
            const details = {
                title: "Are you sure you want to delete this price?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deletePrice(sizeId) : "";
        },
    }
}
</script>
